/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Why_ExclusionsInputs */

const en_us2_profile_why_exclusions = /** @type {(inputs: Profile_Why_ExclusionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you marked as “Don't recommend again”. None of them comes back to the plan unless you ask.`)
};

const pt_br2_profile_why_exclusions = /** @type {(inputs: Profile_Why_ExclusionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que você marcou como “Não recomendar mais”. Nenhum deles volta ao plano sem você pedir.`)
};

const es_419_profile_why_exclusions = /** @type {(inputs: Profile_Why_ExclusionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo que marcaste como “No recomendar más”. Ninguno vuelve al plan a menos que lo pidas.`)
};

const pt_pt2_profile_why_exclusions = /** @type {(inputs: Profile_Why_ExclusionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que marcaste como “Não recomendar mais”. Nenhum deles volta ao plano sem o pedires.`)
};

const fr_fr2_profile_why_exclusions = /** @type {(inputs: Profile_Why_ExclusionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce que tu as marqué « Ne plus recommander ». Aucun ne revient dans le programme sans ta demande.`)
};

const de_de2_profile_why_exclusions = /** @type {(inputs: Profile_Why_ExclusionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was du als „Nicht mehr empfehlen“ markiert hast. Keine davon kommt zurück in den Plan, außer du willst es.`)
};

const it_it2_profile_why_exclusions = /** @type {(inputs: Profile_Why_ExclusionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quello che hai segnato come “Non consigliare più”. Nessuno torna nella scheda se non lo chiedi tu.`)
};

/**
* | output |
* | --- |
* | "What you marked as “Don't recommend again”. None of them comes back to the plan unless you ask." |
*
* @param {Profile_Why_ExclusionsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_why_exclusions = /** @type {((inputs?: Profile_Why_ExclusionsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Why_ExclusionsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_why_exclusions(inputs)
	if (locale === "es-419") return es_419_profile_why_exclusions(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_why_exclusions(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_why_exclusions(inputs)
	if (locale === "de-DE") return de_de2_profile_why_exclusions(inputs)
	if (locale === "it-IT") return it_it2_profile_why_exclusions(inputs)
	return en_us2_profile_why_exclusions(inputs)
});
export { profile_why_exclusions as "profile.why_exclusions" }